import { setAppEnv } from './utils/appEnv';
import { renderStandaloneApp } from './bootstrap';

setAppEnv(import.meta.env as Record<string, string | undefined>);

renderStandaloneApp(document.getElementById('root')!, import.meta.env.VITE_MUI_X_PRO_LICENSE_KEY);
